import { useSessionStorage } from 'usehooks-ts';

export type DismissableState = {
  isDismissed: boolean;
  isOpen: boolean;
  dismiss: () => void;
  onClose: () => void;
};

export function useDismissable(key: string): DismissableState {
  const storageKey = `mo--${key}`;
  const [isDismissed, setIsDismissed] = useSessionStorage(storageKey, false);

  const dismiss = () => setIsDismissed(true);

  return {
    isDismissed,
    isOpen: !isDismissed,
    dismiss,
    onClose: dismiss,
  };
}
